import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { loginUser, logoutUser } from "../Utils/api";
// import { useNavigate } from "react-router-dom";

interface AuthContextProps {
  token: string | undefined;
  setToken: (token: string) => void;
  getStoredToken: () => void;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  eMail: string;
  setEMail: (mail: string) => void;
  name: string;
  setName: (newName: string) => void;
  vorname: string;
  setVorname: (newName: string) => void;
  nachname: string;
  setNachname: (newName: string) => void;
  base: string;
  setBase: (newBase: string) => void;
  bearbeiter: string;
  setBearbeiter: (newBearbeiter: string) => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextProps | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [token, setToken] = useState<string | undefined>();
  const [eMail, setEMail] = useState("");
  const [name, setName] = useState("");
  const [vorname, setVorname] = useState("");
  const [nachname, setNachname] = useState("");
  const [base, setBase] = useState("");
  const [bearbeiter, setBearbeiter] = useState("");
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    getStoredToken();
  }, []);

  const getStoredToken = () => {
    try {
      const storedToken = sessionStorage.getItem("authToken");

      if (storedToken !== null) {
        setToken(storedToken);
      } else {
        // nothing
      }
    } catch (error) {
      console.error("Error retrieving token from sessionStorage:", error);
    } finally {
      setLoading(false); // Set loading to false after checking the token
    }
  };

  const login = async (username: string, password: string) => {
    try {
      const data = await loginUser(username, password);

      if (data !== undefined) {
        // Überprüfe, ob `newToken` nicht null ist

        setToken(data[0]);
        sessionStorage.setItem("token", data[0]);
        setName(username);

        setBearbeiter(data[1]);
        setVorname(data[2]);
        setNachname(data[3]);
      } else {
        // Handle den Fall, wenn `newToken` null ist
        setToken(undefined);
      }
      return true;
    } catch (error) {
      console.error("Login failed", error);
      return false;
    }
  };

  const logout = async () => {
    logoutUser(setToken);
  };

  const contextValue: AuthContextProps = {
    token,
    setToken,
    getStoredToken,
    login,
    logout,
    eMail,
    setEMail,
    name,
    setName,
    vorname,
    setVorname,
    nachname,
    setNachname,
    base,
    setBase,
    bearbeiter,
    setBearbeiter,
    loading,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
